import { FieldError as FieldErrorType } from 'react-hook-form'

export interface FieldErrorProps {
  error: FieldErrorType | undefined
}

export default function FieldError({ error }: FieldErrorProps) {
  return error && (<div className="text-xs text-destructive absolute mt-2">{error.message}</div>)
}
